import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <SpeedInsights />
    <Analytics />
  </React.StrictMode>
);

// Registrar o service worker para funcionalidades de PWA
serviceWorkerRegistration.register({
  onUpdate: registration => {
    // Notificar o usuário sobre a atualização disponível
    const waitingServiceWorker = registration.waiting;
    
    if (waitingServiceWorker && window.confirm('Nova versão disponível! Atualizar agora?')) {
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
  onSuccess: registration => {
    console.log('PWA pronto para uso offline');
  }
});

// Medir performance
reportWebVitals();
